import styled from 'styled-components';
import { typeScale } from '../../../styles/newTypography';
import { Layout } from '../../layout/Layout';
import { LongFormText } from '../../modules/LongformTextModule/LongformTextModule.styles';

export const Wrapper = styled(Layout)`
  ${LongFormText} & {
    grid-column-gap: 0;
  }
`;

export const VideoContainer = styled.div`
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export const Caption = styled.span`
  ${typeScale.desktop.body.xs};
  margin-top: 1rem;
`;
